import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { ConciliationWizardForm } from '../../containers'
import { Session } from '../../../../state/utils/session'

class ConciliationCreatorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_CONCILIATIONS_PATH.replace(':client_id', this.state.session.getClientSession())}>
                        Conciliations
                    </NavLink>
                </li>
                <li>New Conciliation</li>
            </>
    )
  }

  render () {
    return (
            <>

                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={'New Conciliation'}
                        subTitle={'Create a new conciliation'}
                        paths={this.renderHeaderPaths}
                    />
                    <ConciliationWizardForm/>
                </PageContainerLayout>
            </>
    )
  }
}

export { ConciliationCreatorPage }
